module.exports = __webpack_public_path__ + "img/ticket.3eb9a825.svg";